module.exports = __webpack_public_path__ + "static/img/4-WAY STRETCHABLE PU products discription2_deskstop.9e75acf7.jpg";